import { DataTable, Loading, Switch } from "@aidkitorg/component-library";
import { MessageTemplate } from "@aidkitorg/types/lib/survey";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { usePost } from "../../API";
import { useDebouncedEffect } from "../../Hooks/Debounce";

export function PromptDirectory() {
  const getAllMessageTemplates = usePost('/program/admin/prompts/scan');

  const [messageTemplates, setMessageTemplates] = useState<MessageTemplate[]>([]);

  const history = useHistory();
  const [loadingAllTemplates, setLoadingAllTemplates] = useState(false);
  const [onlyShowLatest, setOnlyShowLatest] = useState(true);

  useDebouncedEffect(async () => {
    setLoadingAllTemplates(true);
    try {
      const { nameToVersionsAndDescriptionsMap } = await getAllMessageTemplates({ latestOnly: onlyShowLatest, drafts: 'exclude' });
      const templateNames = Object.keys(nameToVersionsAndDescriptionsMap);
      const templates: MessageTemplate[] = [];
      if (templateNames.length > 0) {
        templateNames.forEach(name => {
          nameToVersionsAndDescriptionsMap[name].forEach(versionAndDescription => {
            templates.push({
              kind: "Message Template",
              instructions: [],
              name: name,
              version: versionAndDescription.version,
              description: versionAndDescription.description,
            } satisfies MessageTemplate);
          });
        });
      }
      setMessageTemplates(templates);
    } finally {
      setLoadingAllTemplates(false);
    }
  }, { dependencies: [onlyShowLatest], maxWait: 1500, timeWindow: 250 });

  return <div className="mt-4 bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg space-y-4 p-2">
    <div className="flex flex-col space-y-2">
      <h2 className="text-lg font-semibold">Directory</h2>
      <Loading loading={loadingAllTemplates}>
        <DataTable
          enableSearch={true}
          searchLabel="Search by name"
          columns={[{
            accessorKey: 'name',
            header: 'Name',
          }, {
            accessorKey: 'version',
            header: 'Version',
          }, {
            accessorKey: 'description',
            header: 'Description',
          }]}
          headerActionButtons={[
            <Switch label="Latest" checked={onlyShowLatest} onCheckedChange={setOnlyShowLatest} />
          ]}
          data={messageTemplates}
          actions={[
            {
              label: 'Edit',
              onClick: (row) => {
                history.push(`/ai/config/prompts?name=${row.name}&version=${row.version}`);
              }
            }
          ]}
        />
      </Loading>
    </div>
  </div>
}
